<template>
  <div class="skeleton--wrapper">
    <div class="skeleton--item mt-2" v-for="(item,index) in 8" :key="index"/>
    <div class="flex justify-center w-full mt-2">
      <p>Carregando...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonAddressInfo'
};
</script>

<style lang="scss">
.skeleton--wrapper {
  height: 405px;
}

.skeleton--item {
  min-width: 584px;
  min-height: 40px;
  background: #f1f3f4;
}

</style>
